import { toast } from "react-toastify";
import firebase from "../../config/firebase";
import { RepositoryFactory } from "repositroy/RepositoryFactory";

export const getAllManagers =
  (filter, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    let manager_data = firebase.firestore().collection("users");

    if (filter) {
      manager_data = manager_data.where("managerID", "==", filter);
    } else {
      manager_data = manager_data.where("managerID", "!=", "");
    }

    if (lastDocument) {
      manager_data = manager_data.startAfter(lastDocument);
    }

    await manager_data
      .limit(5)
      .get()
      .then(async (query) => {
        let data = [];
        if (query.empty) {
          if (filter) {
            toast.warning(
              "This Manager Not Exist. Please Enter Valid Manager ID."
            );
          }
          dispatch({
            type: lastDocument
              ? "GET_ALL_MANAGERS_LOAD_MORE"
              : "GET_ALL_MANAGERS",
            payload: {
              data: [],
              lastDocument: null,
              hasMoreDocument: false
            }
          });
        } else {
          for await (let doc of query.docs) {
            let managerEarning = await firebase
              .firestore()
              .collection("wallet")
              .where("userId", "==", doc.id)
              .get();
            data.push({
              id: doc.id,
              ...doc.data(),
              earnings: managerEarning.empty
                ? 0
                : managerEarning.docs[0].data().amount.toFixed(2)
            });
          }
          dispatch({
            type: lastDocument
              ? "GET_ALL_MANAGERS_LOAD_MORE"
              : "GET_ALL_MANAGERS",
            payload: {
              data: data,
              lastDocument:
                query.docs.length === 5
                  ? query.docs[query.docs.length - 1]
                  : null,
              hasMoreDocument: query.docs.length === 5
            }
          });
        }
        onComplete();
      });
  };

export const getTotalEarningsByModule =
  (id, onComplete = () => {}) =>
  (dispatch) => {
    try {
      firebase
        .firestore()
        .collection("manager_stats")
        .where("managerId", "==", id)
        .get()
        .then(async (query) => {
          dispatch({
            type: "GET_MANAGER_EARNINGS",
            payload: query.docs[0]?.data()
          });
        });
    } catch (error) {
      console.error(error);
    }
  };

export const getTalkingManagerEarning =
  (id, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      let earning_data = firebase
        .firestore()
        .collection("license_talking_purchases")
        .where("managerId", "==", id);
      if (lastDocument) {
        earning_data = earning_data.startAfter(lastDocument);
      }
      await earning_data
        .limit(5)
        .get()
        .then(async (query) => {
          let data = [];
          for await (let doc of query.docs) {
            let athlete_data = await firebase
              .firestore()
              .collection("users")
              .doc(doc.data().athlete_id)
              .get();
            data.push({
              id: doc.id,
              ...doc.data(),
              athlete: athlete_data.data()
            });
          }
          dispatch({
            type: lastDocument
              ? "TALKING_MANAGER_EARNING_LOAD_MORE"
              : "TALKING_MANAGER_EARNING",
            payload: {
              data: data,
              lastDocument: query.docs[data.length - 1],
              hasMoreDocument: data.length >= 5
            }
          });
          onComplete();
        });
    } catch (error) {
      console.error(error);
    }
  };
export const getSeasonalManagerEarning =
  (id, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      let earning_data = firebase
        .firestore()
        .collection("license_seasonal_badges")
        .where("managerId", "==", id);
      if (lastDocument) {
        earning_data = earning_data.startAfter(lastDocument);
      }
      await earning_data
        .limit(5)
        .get()
        .then(async (query) => {
          let data = [];
          for await (let doc of query.docs) {
            let athlete_data = await firebase
              .firestore()
              .collection("users")
              .where("athleteID", "==", doc.data()?.athlete_id)
              .get();
            data.push({
              id: doc.id,
              ...doc.data(),
              athlete: athlete_data.docs[0].data()
            });
          }
          dispatch({
            type: lastDocument
              ? "SEASONAL_MANAGER_EARNING_LOAD_MORE"
              : "SEASONAL_MANAGER_EARNING",
            payload: {
              data: data,
              lastDocument: query.docs[data.length - 1],
              hasMoreDocument: data.length >= 5
            }
          });
          onComplete();
        });
    } catch (error) {
      console.error(error);
    }
  };
export const getMomentoManagerEarning =
  (id, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      let earning_data = firebase
        .firestore()
        .collection("momento_purchases")
        .where("managerId", "==", id);
      if (lastDocument) {
        earning_data = earning_data.startAfter(lastDocument);
      }
      await earning_data
        .limit(5)
        .get()
        .then(async (query) => {
          let data = [];
          for await (let doc of query.docs) {
            let athlete_data = await firebase
              .firestore()
              .collection("users")
              .doc(doc.data().athlete_id)
              .get();
            data.push({
              id: doc.id,
              ...doc.data(),
              athlete: athlete_data.data()
            });
          }
          dispatch({
            type: lastDocument
              ? "MOMENTO_MANAGER_EARNING_LOAD_MORE"
              : "MOMENTO_MANAGER_EARNING",
            payload: {
              data: data,
              lastDocument: query.docs[data.length - 1],
              hasMoreDocument: data.length >= 5
            }
          });
          onComplete();
        });
    } catch (error) {
      console.error(error);
    }
  };
export const getGroupChatManagerEarning =
  (id, lastDocument, onComplete = () => {}) =>
  async (dispatch) => {
    try {
      let earning_data = firebase
        .firestore()
        .collection("new_a4b_chat")
        .where("managerId", "==", id);
      if (lastDocument) {
        earning_data = earning_data.startAfter(lastDocument);
      }
      await earning_data
        .limit(5)
        .get()
        .then(async (query) => {
          let data = [];
          for await (let doc of query.docs) {
            let athlete_data = await firebase
              .firestore()
              .collection("users")
              .doc(doc.data().athleteID)
              .get();
            data.push({
              id: doc.id,
              ...doc.data(),
              athlete: athlete_data.data()
            });
          }
          dispatch({
            type: lastDocument
              ? "GROUP_CHAT_MANAGER_EARNING_LOAD_MORE"
              : "GROUP_CHAT_MANAGER_EARNING",
            payload: {
              data: data,
              lastDocument: query.docs[data.length - 1],
              hasMoreDocument: data.length >= 5
            }
          });
          onComplete();
        });
    } catch (error) {
      console.error(error);
    }
  };
